import { CONFIG } from "../config"
import tfgLogoDark from "../svg/logo-tfg-dark.svg?url"
import tfgLogoLight from "../svg/logo-tfg-light.svg?url"

export class PoweredBy {
  private config: DOMStringMap

  constructor({ config }: { config: DOMStringMap }) {
    this.config = config
    this.render()
  }

  public render(): HTMLDivElement {
    const poweredBy = document.createElement("div")
    poweredBy.className = [CONFIG.PB_CLASS, this.config.tfgPbClass || ""].join(
      " "
    )

    poweredBy.textContent = this.config.tfgPbText || "Powered by"

    const logo = this.createLogoElement()
    if (logo) poweredBy.appendChild(logo)

    return poweredBy
  }

  private createLogoElement(): HTMLImageElement | undefined {
    const logo = document.createElement("img")
    logo.className = [
      CONFIG.PB_LOGO_CLASS,
      this.config.tfgPbLogoClass || "",
    ].join(" ")

    logo.src =
      this.config.tfgLogoVariant === "dark" ? tfgLogoDark : tfgLogoLight
    return logo
  }
}
